export interface ServerSentEvent {
  eventName: string;
  data: string;
}

const EVENT_SEPARATOR = '\n\n';
const EVENT_FIELD_PREFIX = 'event:';
const DATA_FIELD_PREFIX = 'data:';
const COMMENT_PREFIX = ':';
const DEFAULT_EVENT_NAME = 'message';
const OPTIONAL_VALUE_SPACE = ' ';

export interface ServerSentEventParser {
  pushChunk: (chunk: string) => void;
  finish: () => void;
}

function readFieldValue(line: string, prefix: string): string {
  const value = line.slice(prefix.length);
  return value.startsWith(OPTIONAL_VALUE_SPACE) ? value.slice(OPTIONAL_VALUE_SPACE.length) : value;
}

function parseEventBlock(block: string): ServerSentEvent | null {
  let eventName = DEFAULT_EVENT_NAME;
  const dataLines: string[] = [];
  block.split('\n').forEach(function readLine(line) {
    if (line.startsWith(COMMENT_PREFIX)) {
      return;
    }
    if (line.startsWith(EVENT_FIELD_PREFIX)) {
      eventName = readFieldValue(line, EVENT_FIELD_PREFIX);
      return;
    }
    if (line.startsWith(DATA_FIELD_PREFIX)) {
      dataLines.push(readFieldValue(line, DATA_FIELD_PREFIX));
    }
  });
  if (dataLines.length === 0) {
    return null;
  }
  return { eventName, data: dataLines.join('\n') };
}

export function createServerSentEventParser(
  onEvent: (event: ServerSentEvent) => void
): ServerSentEventParser {
  let buffer = '';
  function emitBlock(block: string) {
    const parsedEvent = parseEventBlock(block);
    if (parsedEvent !== null) {
      onEvent(parsedEvent);
    }
  }
  return {
    pushChunk: function pushChunk(chunk: string): void {
      buffer = (buffer + chunk).replace(/\r\n/g, '\n');
      let separatorIndex = buffer.indexOf(EVENT_SEPARATOR);
      while (separatorIndex !== -1) {
        const block = buffer.slice(0, separatorIndex);
        buffer = buffer.slice(separatorIndex + EVENT_SEPARATOR.length);
        emitBlock(block);
        separatorIndex = buffer.indexOf(EVENT_SEPARATOR);
      }
    },
    finish: function finish(): void {
      const remaining = buffer.replace(/\r\n/g, '\n').replace(/\n+$/, '');
      buffer = '';
      if (remaining.length > 0) {
        emitBlock(remaining);
      }
    },
  };
}
